import { API_endpoints } from "../config"; 

export const fetchWorkSlots = async (): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.WorkTimeSlots); 

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching work slots:", error);
        throw error;
    }
};

export const fetchHolidaySlots = async (): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.HolidaySlots); 

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }


        const data = await response.json();

        return data; 
    } catch (error) {
        console.error("Error fetching holiday slots:", error);
        throw error;
    }
};
